import * as tslib_1 from "tslib";
import { utils } from "../../common";
import { IS_DEBUG, IS_DINGTALK, IS_IOS, IS_IE, IS_WECHAT, IS_WECHAT_PC_MAC, IS_WECHAT_PC_WINDOW, } from "./is-platform";
import { BrowserService } from "./platform-service";
import { Base64 } from "js-base64";
function parseToken(token) {
    const useInfoBs = token.split(".")[1];
    const useInfo = JSON.parse(Base64.decode(useInfoBs));
    return useInfo;
}
export { IS_DEBUG, IS_DINGTALK, IS_IOS, IS_IE, IS_WECHAT, IS_WECHAT_PC_MAC, IS_WECHAT_PC_WINDOW, };
let service = new BrowserService();
export function start(client_id, scope) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        let _service = null;
        let query = utils.parseQuery();
        console.log(query, 'query');
        let urls = window.location.pathname;
        let loginInfo;
        let p = null;
        if (IS_DEBUG) {
        }
        else {
            let currentUrl = new URL(location.href);
            let tokenTradeToken = currentUrl.searchParams.get('tokenTradeToken');
            console.log('tokenTradeToken', tokenTradeToken);
            if (!tokenTradeToken) {
                if (IS_DINGTALK) {
                    const dingtalk = yield import(
                    /* webpackChunkName: "dingtalk" */ "./dingtalk");
                    p = dingtalk.init(client_id, scope, query);
                    _service = new dingtalk.DingTalkService();
                }
                if (IS_WECHAT) {
                    // 企业微信统一配置pc端地址，在此判断是否跳转至移动端
                    if (IS_WECHAT_PC_MAC || IS_WECHAT_PC_WINDOW) {
                        const wechat = yield import(
                        /* webpackChunkName: "dingtalk" */ "./wechat");
                        p = wechat.init(client_id, scope, query);
                        _service = new wechat.WechatService();
                    }
                    else {
                        if (window.location.href.indexOf("mobile") <= -1) {
                            const { origin, search } = window.location;
                            const url = `${origin}/mobile${search}`;
                            window.location.href = url;
                            return;
                        }
                        else {
                            const wechat = yield import(
                            /* webpackChunkName: "dingtalk" */ "./wechat");
                            p = wechat.init(client_id, scope, query);
                            _service = new wechat.WechatService();
                        }
                    }
                }
            }
        }
        if (_service) {
            service = _service;
        }
        if (p) {
            const res = yield p;
            if (res) {
                const { access_token, userinfo, refresh_token, expiration } = res;
                loginInfo = res;
                const info = parseToken(access_token);
                if (info) {
                    const user = userinfo;
                    user.isAppAdmin = info.isAppAdmin;
                    user.isAdmin = info.isAdmin;
                }
                sessionStorage.setItem("user", JSON.stringify(userinfo));
                localStorage.setItem("token", access_token);
                localStorage.setItem("refresh_token", JSON.stringify(refresh_token));
                localStorage.setItem("expireTime", `${expiration}`);
            }
        }
        else {
            utils.copyURL(query, 'portal');
        }
        return {
            query,
            loginInfo,
        };
    });
}
export { service };
